var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6695_943)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0575 5.40992C11.3076 5.14745 11.6467 5 12.0002 5C12.3538 5 12.6929 5.14745 12.9429 5.40992L15.6096 8.21004C15.796 8.40584 15.923 8.65528 15.9744 8.92683C16.0258 9.19837 15.9994 9.47983 15.8985 9.73562C15.7976 9.99141 15.6268 10.21 15.4076 10.3639C15.1883 10.5177 14.9306 10.5999 14.6669 10.5999H9.33351C9.06984 10.5999 8.8121 10.5177 8.59289 10.3639C8.37367 10.21 8.20281 9.99141 8.10192 9.73562C8.00102 9.47983 7.97462 9.19837 8.02604 8.92683C8.07747 8.65528 8.20441 8.40584 8.39083 8.21004L11.0575 5.40992ZM8.10149 14.2639C8.20248 14.0081 8.37344 13.7895 8.59273 13.6358C8.81203 13.482 9.06982 13.4 9.33351 13.4001H14.6669C14.9306 13.4001 15.1883 13.4823 15.4076 13.6361C15.6268 13.79 15.7976 14.0086 15.8985 14.2644C15.9994 14.5202 16.0258 14.8016 15.9744 15.0732C15.923 15.3447 15.796 15.5942 15.6096 15.79L12.9429 18.5901C12.6929 18.8526 12.3538 19 12.0002 19C11.6467 19 11.3076 18.8526 11.0575 18.5901L8.39083 15.79C8.20425 15.5942 8.07717 15.3447 8.02566 15.073C7.97416 14.8014 8.00055 14.5198 8.10149 14.2639Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6695_943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.16deb5af2285b355e87419f2ec0ecbed.svg";
export { ForwardRef as ReactComponent };